import React from 'react'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'
import InfoIcon from '@material-ui/icons/Info'
import Button from 'components/Button'

type Props = React.ComponentProps<typeof Button> & {

}

const styles = (theme: Theme) => createStyles({
  icon: {
    marginRight: theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const HelpButton: React.SFC<InjectedProps> = ({ children, classes, ...props }) => {
  return (
    <Button
      color="accent"
      {...props}
    >
      <InfoIcon className={classes.icon} />
      {children}
    </Button>
  )
}

export default withStyles(styles)(HelpButton)
